import { abUseExperimentsSelector, isAbUseExperimentsActive } from 'shared/selectors/abUseExperiments';

import type { IState } from 'shared/store';

export const NEWBUILDING_BOOKING_AUTH_EXPERIMENT = 'newbuilding_booking_authorization_desktop';

// TODO: Удалить селектор и константу в CD-268729.
export const selectIsNewbuildingBookingAuthExperiment = (state: IState): boolean => {
  const experiments = abUseExperimentsSelector(state);

  return isAbUseExperimentsActive(experiments, NEWBUILDING_BOOKING_AUTH_EXPERIMENT, 'B');
};
